import * as React from "react";
import { useTheme as useTheme$1 } from "@mui/system";
import defaultTheme from "./defaultTheme.es.js";
import THEME_ID from "./identifier.es.js";
function useTheme() {
  const theme = useTheme$1(defaultTheme);
  if (process.env.NODE_ENV !== "production") {
    React.useDebugValue(theme);
  }
  return theme[THEME_ID] || theme;
}
export {
  useTheme as default
};
//# sourceMappingURL=useTheme.es.js.map
